/**
 * Extrai chips legíveis do snapshot Chatwoot (mesmos critérios de formatSnapshotHighlights).
 * @returns {{ label: string, value: string, testId?: string }[]}
 */
export function getSnapshotChipItems(snapshot) {
    if (!snapshot || typeof snapshot !== "object") return [];

    const items = [];

    if (snapshot.status) {
        items.push({
            label: "status",
            value: String(snapshot.status),
            testId: "cw-chip-status",
        });
    }

    const assignee = snapshot.meta?.assignee ?? snapshot.assignee;
    if (assignee !== undefined) {
        items.push({
            label: "assignee",
            value: assignee == null ? "ausente" : "presente",
            testId: "cw-chip-assignee",
        });
    }

    const attrs = snapshot.custom_attributes;
    if (attrs && typeof attrs === "object" && Object.keys(attrs).length > 0) {
        for (const [key, val] of Object.entries(attrs)) {
            items.push({
                label: key,
                value: val == null ? "—" : String(val),
                testId: `cw-chip-attr-${key}`,
            });
        }
    }

    return items;
}

const TONE_BY_LABEL = {
    status: "border-emerald-600/50 bg-emerald-950/40 text-emerald-100",
    assignee: "border-sky-600/50 bg-sky-950/40 text-sky-100",
};

function chipTone(label) {
    return TONE_BY_LABEL[label] ?? "border-gray-600/70 bg-gray-800/70 text-gray-200";
}

function SnapshotChip({ label, value, testId }) {
    return (
        <span
            className={`inline-flex items-center gap-1 rounded border px-1.5 py-0.5 ${chipTone(label)}`}
            data-testid={testId}
        >
            <span className="text-[9px] uppercase tracking-wide opacity-70">{label}</span>
            <span className="text-[11px] font-medium">{value}</span>
        </span>
    );
}

export default function FlowChatwootChips({ snapshot }) {
    const items = getSnapshotChipItems(snapshot);
    if (items.length === 0) return null;

    return (
        <div
            className="flex flex-wrap gap-1"
            aria-label="Chatwoot resumo"
            data-testid="flow-chatwoot-chips"
        >
            {items.map((item) => (
                <SnapshotChip
                    key={`${item.label}-${item.value}`}
                    label={item.label}
                    value={item.value}
                    testId={item.testId}
                />
            ))}
        </div>
    );
}
